export default "__VITE_ASSET__637f72ab__"